import React from 'react';

import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer id={styles.footer}>
      <nav id={styles.footerNavigation}>
        <a className={styles.footerNavigationLink} href="/legal">Legal</a>
      </nav>
    </footer>
  );
};

export default Footer;
